import { Injectable } from '@angular/core';
import { DataStoreService } from '../../core/services/data-store/data-store.service';
import { FunctionDesc } from '../../models/configuration.model';
import { FunctionStoreService } from '../function-store/function-store.service';

@Injectable()
export class ViewSelectorService {
  constructor(private functionStore: FunctionStoreService, private dataStore: DataStoreService) {}

  setActiveView(view: FunctionDesc): void {
    this.dataStore.currentViewName = view.displayName.name;
    this.dataStore.setCurrentView(view);
    this.dataStore.setShowGrid(true);
  }

  setActiveViewById(id: string): void {
    const view = this.findViewById(id);
    if (view && this.dataStore.currentNodeObject !== view) {
      this.setActiveView(view);
    }
  }

  findViewById(id: string): FunctionDesc {
    if (id === 'NOT-EGIB-SINGLE') {
      id = 'NOT-EGIB';
    }
    let found = null;
    const views = this.functionStore.allFunctionsValue;
    if (views) {
      views.some(parent => {
        found = parent.functions.find(child => child.id === id);
        return found !== null;
      });
    }

    return found;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/view-selector/view-selector.service.ts